const logging = require('@sstdev/lib_logging');
const dataAccessMethods = require('../../../dataAccessMethods');
const Blockly = require('blockly');
const baseMdcBlockGroup = require('../_BaseMdcBlockGroup');

const TOOLTIPS = {
    GreedyColumnLayout: 'Display children in a single column, taking as much width as possible',
    SummaryDetailLayout:
        'Most CRUD pages. List of record, with on click the detail of the record (list section greedy).',
    SpaceApartLayout:
        'Displays content with even space BETWEEN the components (e.g. for buttons spread evenly over the space)',
    EvenColumnLayout: 'displays content in even width columns (nothing greedy). E.g. Sequential Print form.',
    TabViewLayout: 'Generates a tabs for each child, using the title of the child as tab text.',
    DetailHSplitLayout: 'IMPLEMENTATION PENDING. List on top, detail pane on the bottom half.',
    DetailVSplitLayout: 'DEPRECATED. use Summary Detail Layout instead.',
    MosaicLayout: 'IMPLEMENTATION PENDING',
    FilterBoundaryLayout: 'Wraps child components in a FilterInterdependencyBoundary context',
    FormElementLayout: 'Contains children that need to be treated as a Form Element for proper form formatting (e.g. for form scrollbars to work correctly)'
};

const hNodeTypes = require('./types');

class Layout extends baseMdcBlockGroup {

    constructor(hNodeTypeGroup, categorySpec, color, subset = '') {
        super(hNodeTypeGroup, categorySpec, color, subset);
        super.types = hNodeTypes;
    }

    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        // all layouts including those in separate files get the following fields
        let dropdownNamespace = blocklyBlock.getFieldValue('defaultNamespace');
        let dropdownRelation = blocklyBlock.getFieldValue('defaultRelation');
        code.defaultNamespace = dropdownNamespace;
        code.defaultRelation = dropdownRelation;
        code.defaultDetailWidth = blocklyBlock.getFieldValue('defaultDetailWidth');

        code.darkenBackground = /true/i.test(blocklyBlock.getFieldValue('darkenBackground'));
        if (hNodeType === 'LeftAlignLayout') code.wrap = /true/i.test(blocklyBlock.getFieldValue('wrap'));

        // add the rest of the custom fields for layouts in separate files
        if (this.types[hNodeType]?.convertCustomFieldsToCode) {
            const resultCode = this.types[hNodeType].convertCustomFieldsToCode(code, blocklyBlock);
            if (typeof resultCode === 'string') {
                logging.error(
                    `${hNodeType}.convertCustomFieldsToCode should not return a string. It should return a JSON object instead.`
                );
                return resultCode;
            }
            return JSON.stringify(resultCode);
        }

        // handle layouts not specified in other files
        if (hNodeType == 'MosaicLayout') {
            code.alwaysVisible = JSON.parse(
                '[' + Blockly.JavaScript.statementToCode(blocklyBlock, 'alwaysVisible') + ']'
            );
            code.initiallyVisible = JSON.parse(
                '[' + Blockly.JavaScript.statementToCode(blocklyBlock, 'initiallyVisible') + ']'
            );
            code.initiallyHidden = JSON.parse(
                '[' + Blockly.JavaScript.statementToCode(blocklyBlock, 'initiallyHidden') + ']'
            );
        }

        return JSON.stringify(code);
    }
    addToBlocksCustom(color, blocklyBlock, hNodeType, mdcBlock, topInput) {

        // all layouts including those in separate files get the following fields
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        topInput
            .appendField('  Default Namespace:')
            .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'defaultNamespace')
            .appendField('  Default Relation:')
            .appendField(
                new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                'defaultRelation'
            );

        // add the rest of the custom fields for layouts in separate files
        if (this.types[hNodeType]) {
            this.types[hNodeType]?.addBlockSpecificFields(color, blocklyBlock, mdcBlock, topInput);
            return;
        }

        // handle layouts not specified in other files

        if (TOOLTIPS[hNodeType]) {
            blocklyBlock.setTooltip(TOOLTIPS[hNodeType]);
        }

        // These blocks have inputsInline(true) through the baseMdcBlockGroup
        // All these separate inputs end up on the same line

        if (['DetailHSplitLayout', 'DetailVSplitLayout', 'SummaryDetailLayout'].includes(hNodeType)) {
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Initial Detail Pane %:', '')
                // 30 default value
                // 0 min value
                // 100 max value
                // 0 decimal places
                .appendField(new Blockly.FieldNumber(30, 0, 100, 0), 'defaultDetailWidth');
            blocklyBlock.additionalListNames = ['list'];
        }
        if (hNodeType === 'TabLayout') {
            // Slight hack to ensure there are children inputs (which happen after this code
            // if going sequentially)
            setTimeout(function () {
                const children = blocklyBlock.getInput('children');
                children.setCheck(['layout']); // only allow layouts inside tab or it will get wacky.
            }, 1);
        }
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Darken Background')
            .appendField(new Blockly.FieldCheckbox('false'), 'darkenBackground');

        if (hNodeType === 'LeftAlignLayout') {
            blocklyBlock
                .appendDummyInput()
                .appendField('  Wrap Children')
                .appendField(new Blockly.FieldCheckbox('false'), 'wrap');
        }

        if (hNodeType === 'DetailHSplitLayout') {
            blocklyBlock
                .appendStatementInput('list')
                .setAlign(Blockly.ALIGN_RIGHT)
                .setCheck(['list', 'layout'])
                .appendField('Controls Up Top:', 'list');
            blocklyBlock
                .appendStatementInput('children')
                .setCheck(['detailPane'])
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('Detail Pane(s):', 'childrenField');
        } else if (['DetailVSplitLayout', 'SummaryDetailLayout'].includes(hNodeType)) {
            blocklyBlock
                .appendStatementInput('list')
                .setAlign(Blockly.ALIGN_RIGHT)
                .setCheck(['list', 'layout'])
                .appendField('List:', 'list');
            blocklyBlock
                .appendStatementInput('children')
                .setCheck(['detailPane'])
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('Detail Pane(s):', 'childrenField');
        } else if (hNodeType === 'MosaicLayout') {
            blocklyBlock
                .appendStatementInput('extraButtons')
                .setCheck(['actionElement'])
                .appendField('Toolbar Buttons:');
            blocklyBlock
                .appendStatementInput('alwaysVisible')
                .setAlign(Blockly.ALIGN_RIGHT)
                .setCheck(['layout', 'list', 'blockly'])
                .appendField('Always Visible:', 'alwaysVisible');
            blocklyBlock
                .appendStatementInput('initiallyVisible')
                .setAlign(Blockly.ALIGN_RIGHT)
                .setCheck(['layout', 'list', 'blockly'])
                .appendField('Initially Visible:', 'initiallyVisible');
            blocklyBlock
                .appendStatementInput('initiallyHidden')
                .setAlign(Blockly.ALIGN_RIGHT)
                .setCheck(['layout', 'list', 'blockly'])
                .appendField('Initially Hidden:', 'initiallyHidden');
        } else {
            blocklyBlock
                .appendStatementInput('children')
                .setCheck(mdcBlock.allowedChildrenTypes)
                .appendField('Children:', 'childrenField');
        }

        if (['DetailVSplitLayout', 'DetailHSplitLayout', 'MosaicLayout'].includes(hNodeType)) {
            blocklyBlock.setEnabled(false);
        }

        if (hNodeType === 'FilterBoundaryLayout') {
            blocklyBlock.setColour('#888');
        }
    }
}

module.exports = Layout;
